import { Reveal, ChapterHeader } from "./Reveal";
import { Container, Zap, Wind, Droplets } from "lucide-react";
import { useLang } from "../i18n";
import { useGallery } from "../gallery";

const IMG = "https://images.unsplash.com/photo-1634834576400-56f5e1ad8db8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwZmFjdG9yeSUyMGludGVyaW9yJTIwaGVhdnklMjBtYWNoaW5lcnklMjBzdGVlbCUyMGNyYW5lfGVufDB8fHx8MTc4OTQ2OTU3NHww&ixlib=rb-4.1.0&q=85";

export const ProductionSpaces = () => {
  const { t } = useLang();
  const { sections } = useGallery();
  const img = sections.production ? `${process.env.REACT_APP_BACKEND_URL}${sections.production.url}` : IMG;
  const SPECS = [
    { value: "250,0 m²", label: t("spec1l"), note: t("spec1n") },
    { value: "935,6 m²", label: t("spec2l"), note: t("spec2n") },
    { value: "178,2 m²", label: t("spec3l"), note: t("spec3n") },
  ];
  const TECH = [
    { icon: Container, text: t("tech1") },
    { icon: Zap, text: t("tech2") },
    { icon: Wind, text: t("tech3") },
    { icon: Droplets, text: t("tech4") },
  ];

  return (
  <section id="priestory" data-testid="production-section" className="py-20 lg:py-28 px-4 sm:px-8 max-w-7xl mx-auto">
    <ChapterHeader number="01" eyebrow={t("c1_eyebrow")} title={t("c1_title")} />

    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
      <div>
        <Reveal>
          <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-10">
            {t("c1_text")}
          </p>
        </Reveal>

        <div className="space-y-0 border-t border-steelborder">
          {SPECS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div data-testid={`spec-card-${i}`}
                className="group flex items-baseline justify-between gap-6 border-b border-steelborder py-5 hover:bg-gunmetal/60 transition-colors duration-300 px-2 -mx-2">
                <div>
                  <p className="font-heading text-xl font-bold uppercase tracking-wide text-slate-200 group-hover:text-safety transition-colors duration-300">{s.label}</p>
                  <p className="text-sm text-slate-500 mt-0.5">{s.note}</p>
                </div>
                <p className="font-mono text-2xl sm:text-3xl font-bold text-safety whitespace-nowrap">{s.value}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          {TECH.map((item, i) => (
            <Reveal key={item.text} delay={i * 0.06}>
              <div data-testid={`tech-badge-${i}`}
                className="flex items-center gap-3 border border-steelborder bg-steelcard p-4 hover:border-safety/60 transition-colors duration-300">
                <item.icon className="w-5 h-5 text-safety shrink-0" />
                <p className="text-sm text-slate-300">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15} className="lg:sticky lg:top-24">
        <div className="relative border border-steelborder">
          <div className="absolute -top-3 -left-3 w-16 h-16 border-t-2 border-l-2 border-safety z-10" />
          <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-2 border-r-2 border-safety z-10" />
          <img src={img} alt={t("c1_title")} className="w-full h-[420px] lg:h-[560px] object-cover spotlight-img" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
          <div className="absolute bottom-4 left-4 font-mono text-xs tracking-[0.2em] uppercase text-slate-300 bg-ink/70 backdrop-blur px-3 py-1.5 border border-steelborder">
            {t("c1_img")}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
